<script lang="ts" setup>

interface Properties {
  name?: string;
  label?: string;
  required?: boolean;
  checked?: boolean;
  dataQa?: string;
}

withDefaults(defineProps<Properties>(), {
  name: () => '',
  label: () => '',
  required: () => false,
  checked: () => false,
  dataQa: () => '',
});
defineEmits(['update:checked']);
</script>

<template>
  <input :name="name"
         :required="required"
         type="checkbox"
         :checked="checked"
         class="w-4 h-4 mr-2 bg-gray-100 border-gray-400 rounded"
         :data-qa="dataQa"
         @change="$emit('update:checked', ($event.target as HTMLInputElement).checked)"/>

  <label v-if="label" :for="name">{{ label }}</label>
</template>
